import { render, staticRenderFns } from "./RiskThreatPart.vue?vue&type=template&id=c8ed5202&scoped=true"
import script from "./RiskThreatPart.vue?vue&type=script&lang=js"
export * from "./RiskThreatPart.vue?vue&type=script&lang=js"
import style0 from "./RiskThreatPart.vue?vue&type=style&index=0&id=c8ed5202&prod&scoped=true&lang=css"
import style1 from "./RiskThreatPart.vue?vue&type=style&index=1&id=c8ed5202&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ed5202",
  null
  
)

export default component.exports